import { createAction } from "redux-actions";
import {
  GET_PAYTMENT_METHODS_SUCCESS,
  GET_PAYTMENT_METHODS_FAILURE,
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
  SET_DEFAULT_PAYMENT_METHOD_FAILURE,
  GET_PAYTMENT_METHODS_LOADING,
  GET_PAYMENT_METHODS_FOR_USER_SUCCESS,
  GET_PAYMENT_METHODS_FOR_USER_FAILURE,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAILURE,
} from "../constants/actionTypes";
import * as Credentials from "../api/credentials";

const getPaymetMethodsSuccess = createAction(GET_PAYTMENT_METHODS_SUCCESS);
const getPaymetMethodsFailure = createAction(GET_PAYTMENT_METHODS_FAILURE);
const setPaymentsLoading = createAction(GET_PAYTMENT_METHODS_LOADING);

export function getPaymetMethods(params, forceRefresh = false) {
  return async (dispatch, getState) => {
    const { loaded } = getState().credentials;

    if (!forceRefresh && loaded) {
      return Promise.resolve({
        payload: getState().credentials,
      });
    }

    dispatch(setPaymentsLoading(true));

    try {
      try {
        const { data } = await Credentials.getPaymetMethods(params);
        return dispatch(getPaymetMethodsSuccess(data));
      } catch (error) {
        return dispatch(getPaymetMethodsFailure(error));
      }
    } finally {
      dispatch(setPaymentsLoading(false));
    }
  };
}

const getPaymetMethodsForUserSuccess = createAction(
  GET_PAYMENT_METHODS_FOR_USER_SUCCESS
);
const getPaymetMethodsForUserFailure = createAction(
  GET_PAYMENT_METHODS_FOR_USER_FAILURE
);

export function getPaymetMethodsForUser(params) {
  return (dispatch) =>
    Credentials.getPaymetMethodsForUser(params)
      .then(({ data }) => dispatch(getPaymetMethodsForUserSuccess(data)))
      .catch((error) => dispatch(getPaymetMethodsForUserFailure(error)));
}

const setDefaultPaymentMethodSuccess = createAction(
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS
);
const setDefaultPaymentMethodFailure = createAction(
  SET_DEFAULT_PAYMENT_METHOD_FAILURE
);

export function setDefaultPaymentMethod(params) {
  return (dispatch) =>
    Credentials.setDefaultPaymentMethod(params)
      .then(({ data }) => dispatch(setDefaultPaymentMethodSuccess(data)))
      .catch((error) => dispatch(setDefaultPaymentMethodFailure(error)));
}

const deletePaymentMethodSuccess = createAction(DELETE_PAYMENT_METHOD_SUCCESS);
const deletePaymentMethodFailure = createAction(DELETE_PAYMENT_METHOD_FAILURE);

export function deletePaymentMethod(query) {
  return (dispatch) =>
    Credentials.deletePaymentMethod(query)
      .then(({ data }) => {
        dispatch(deletePaymentMethodSuccess(data));
        return data;
      })
      .catch((error) => {
        dispatch(deletePaymentMethodFailure(error));
        throw error;
      });
}
